import { render, staticRenderFns } from "./DataNull.vue?vue&type=template&id=4d90b270&scoped=true"
import script from "./DataNull.vue?vue&type=script&lang=js"
export * from "./DataNull.vue?vue&type=script&lang=js"
import style0 from "./DataNull.vue?vue&type=style&index=0&id=4d90b270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90b270",
  null
  
)

export default component.exports